import 'babel-polyfill';
import Promise from 'promise-polyfill';
// To add to window
if (!window.Promise) {
  window.Promise = Promise;
}
import "core-js/stable";
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, Switch, Redirect, Link } from 'react-router-dom';

import BroadcastChannel from 'broadcast-channel';

import { createBrowserHistory } from 'history';
import { Provider } from 'mobx-react';
import { syncHistoryWithStore } from 'mobx-react-router';

import '@sogei/react-web-components-catalog/dist/css/uikit.css'
import '@sogei/react-web-components-catalog/dist/css/uikit/agenzia-entrate.css'
import { PATH_INIT } from './config/portale-config'
/* layouts */
import 'Css/app.css';
import { Spinner, AuthMenu, AuthFooter, Messages } from './containers/layout'
/* Component */
import Header from './components/header.jsx'
import Errore from './components/errore.jsx'
import Iscrizione from './components/richiestaRegistrazione/iscrizione.jsx';
import Riepilogo from './components/widgets/riepilogo.jsx'


import RootStore from './stores'


const rootStore = new RootStore();
const browserHistory = createBrowserHistory();
const history = syncHistoryWithStore(browserHistory, rootStore.routingStore);

const channel = new BroadcastChannel('portale-agenzia-entrate');

class App extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      init: true,
      forwardRoute: true
    };
  }

  componentDidMount () {
/* 
    channel.onmessage = function (path) {
      rootStore.refreshStore()
      this.setState({ forwardRoute: false })
      rootStore.routingStore.push(path)
    }.bind(this) */

    /*     rootStore.service.doAjax('GET', PATH_INIT).then(init => {
          this.setState({ init: true })
        }) */

 /*    this.unsubscribeFromStore = history.subscribe((location, action) => {
      if (this.state.forwardRoute) {
        channel.postMessage(location.pathname);
        rootStore.uiStore.clearMessages()
      } else {
        this.setState({ forwardRoute: true })
      }
    }); */
  }

  componentWillUnmount () {
 /*    this.unsubscribeFromStore()
    channel.close(); */
  }
  /*  <Route to="/home" component={Home} />
              <Route to="/iscrizione" component={Iscrizione} /> */
  render () {
    return (

      this.state.init ?
        <React.Fragment>
          <Header></Header>
          <AuthMenu></AuthMenu>

          <Spinner></Spinner>
          <Messages extraClass={["container-fluid", "py-3", "py-md-4"]}></Messages>

          <Switch>

            <Route path={`${ process.env.CONTEXT_PATH }/esito`} component={Riepilogo} />
            <Route path={`${ process.env.CONTEXT_PATH }/error`} component={Errore} />
            <Route path={`${ process.env.CONTEXT_PATH }/home`} component={Iscrizione} />

            <Redirect to={process.env.CONTEXT_PATH + '/home'} />
          </Switch>

          <AuthFooter></AuthFooter>

        </React.Fragment> : null
    )
  }
}

ReactDOM.render((
  <Router history={history}>
    <Provider rootStore={rootStore}><App /></Provider>
  </Router>
), document.getElementById('root'))
